import { IDateRangeValue, ISelectedOperatorInfo, IHierarchyValue } from '../types/faceted-filter.types';
import { FilterUtils } from './filter.utils';

export class DisplayValue {
  public static FromPath(path: string): string {
    return path.replace(/\|/g, ' > ');
  }

  public static FromStringArray(values: string[], path: string): string {
    const firstValue = values[0] ?? '';
    const valueDisplay: string = values.length > 1 ? `${firstValue} + ${values.length - 1} more` : firstValue;

    return `${this.formatPathDisplay(path)}: ${valueDisplay}`;
  }

  public static FromBooleanStringArray(values: string[], path: string): string {
    return `${this.formatPathDisplay(path, true)}: ${values[0] ?? ''}`;
  }

  public static FromDateRange(value: IDateRangeValue, path: string, showDateRange: boolean = true): string {
    if (!showDateRange) {
      return FilterUtils.pathToDisplayPathsList(path).join(': ');
    }

    const valueDisplay = `${value.startDate} - ${value.endDate}`;

    return `${this.formatPathDisplay(path, true)}: ${valueDisplay}`;
  }

  public static FromOperatorValue(value: ISelectedOperatorInfo, path: string): string {
    const valueDisplay = `${value.operatorInfo.label} ${value.operand}`;

    return `${this.formatPathDisplay(path)} ${valueDisplay}`;
  }

  public static FromHierarchies(values: IHierarchyValue[], _path: string, valuesAreFacets: boolean): string {
    // Based on feedback, we want to preserve the first path (Dealers). TODO: need to verify
    // const pathRoot = _path.split('|')[0] + ' > ';
    let valueDisplay: string;
    const firstValue = values[0];
    if (!valuesAreFacets) {
      valueDisplay = values.map((v) => v.value).join(', ');
    } else {
      valueDisplay =
        values.length > 1 ? `${firstValue?.value ?? ''} + ${values.length - 1} more` : (firstValue?.value ?? '');
    }
    // const omitLastNode = valuesAreFacets && values.length === 1;
    // const displayPaths: string = this.formatPathDisplay(_path, omitLastNode);
    // return `${pathRoot}${displayPaths}${displayPaths.length ? ':' : ''} ${valueDisplay}`;
    return valueDisplay;
  }

  private static formatPathDisplay(path: string, omitLastNode: boolean = false): string {
    const pathsList = FilterUtils.pathToDisplayPathsList(path);

    if (omitLastNode) pathsList.pop();

    return pathsList.join(' > ');
  }
}
